import { Box, Button, Container, Rating, Stack } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { retrievePopularDishes } from "./selector";
import { Product } from "../../../lib/types/product";
import React from "react";
import { serverApi } from "../../../lib/config";
import { CartItem } from "../../../lib/types/search";
import { useHistory } from "react-router-dom";
import { sweetTopSuccessAlert } from "../../../lib/sweetAlert";

const popularDishesRetriever = createSelector(
  retrievePopularDishes,
  (popularDishes) => ({ popularDishes })
);

interface PopularDishesProps {
  onAdd: (item: CartItem) => void;
}

export default function PopularDishes(props: PopularDishesProps) {
  const { onAdd } = props;
  const { popularDishes } = useSelector(popularDishesRetriever);
  const history = useHistory();

  const addToBasket = (e: React.MouseEvent, product: Product) => {
    e.stopPropagation();
    onAdd({
      _id: product._id,
      quantity: 1,
      name: product.productName,
      price: product.productPrice,
      image: product.productImages[0],
    });
    sweetTopSuccessAlert("Added to basket", 700);
  };

  return (
    <div className="popular-dishes-frame">
      <Container>
        <Stack className="popular-section">
          <Box className="category-title">Popular Books</Box>
          <Stack className="cards-frame">
            {popularDishes.length !== 0 ? (
              popularDishes.map((product: Product) => {
                const imagePath = `${serverApi}/${product.productImages[0]}`;
                const rating = product.productRating || 5;
                return (
                  <Box
                    key={product._id}
                    className="popular-book-card"
                    onClick={() => history.push(`/products/${product._id}`)}
                  >
                    <Box
                      className="popular-book-cover"
                      sx={{ backgroundImage: `url(${imagePath})` }}
                    >
                      <span className="bestseller-badge">Bestseller</span>
                      <div className="popular-hover">
                        <Button
                          className="add-basket-btn"
                          variant="contained"
                          startIcon={<ShoppingCartOutlinedIcon />}
                          onClick={(e) => addToBasket(e, product)}
                        >
                          Add to Basket
                        </Button>
                      </div>
                    </Box>
                    <Box className="popular-book-body">
                      <Stack
                        direction="row"
                        alignItems="center"
                        className="rating-row"
                        spacing={0.5}
                      >
                        <Rating value={rating} precision={0.1} readOnly size="small" />
                        <span className="rating-num">({rating.toFixed(1)})</span>
                      </Stack>
                      <strong className="book-title">{product.productName}</strong>
                      <span className="book-author">
                        {product.productAuthor || product.productDesc || "Author"}
                      </span>
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        className="book-meta-row"
                      >
                        <span className="meta-views">
                          <VisibilityIcon sx={{ fontSize: 16 }} />
                          {product.productViews}
                        </span>
                        <span className="meta-price">{product.productPrice} $</span>
                        <span className="meta-likes">
                          <FavoriteBorderIcon sx={{ fontSize: 16 }} />
                          {product.productLikes ?? 0}
                        </span>
                      </Stack>
                    </Box>
                  </Box>
                );
              })
            ) : (
              <Box className="no-data">Popular books are not available!</Box>
            )}
          </Stack>
        </Stack>
      </Container>
    </div>
  );
}
